import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ReportService } from '../../../../../common/services/Report.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { HistoryConst } from './history.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import { TableAction } from '../../../../../components/table-component/table.const';
import { BsModalService, csLocale, trLocale } from 'ngx-bootstrap';
import { UserService } from '../../../../../common/services/User.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import { CampaignService } from '../../../../../common/services/Campaign.service';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { Role } from '../../setting/expert/agent/agent.const';
import { BaseComponent } from 'app/components/base.component';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { process } from '../../../../../components/process/process.listener';
import { showPhoneNumberInString } from '../../../../../common/utils/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'report-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
  providers: [ReportService, BsModalService, ExportService, UserService, QueueService, CampaignService],
})
export class HistoryComponent extends BaseListComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  @ViewChild('audioFile') audioFile: ElementRef;
  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  public displayModel: any = {};
  public audio_path: any;
  public data_page_divide: any;
  public exportData: any = [];
  public allAgent: any = [];
  public allQueue: any = [];
  public campaigns: any = [];
  public Roles: any = Role;
  public displayColumnsExport: any = [];

  protected readonly trLocale = trLocale;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportService: ExportService,
    private userService: UserService,
    private queueService: QueueService,
    private campaignService: CampaignService
  ) {
    super(changeDetector, toastr, modalService);

    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
      callType: '-1',
      caller: '',
      called: '',
      callId: '',
      agentId: '',
      username: '',
      duration: '',
      campaignId: '',
      acdTimeGt: '',
      acdTimeLt: '',
      queueId: '',
    };
    this.swapModel(0);
    this.displayColumns = HistoryConst.displayColumns();
    this.displayColumnsExport = HistoryConst.displayColumnsExport();
  }

  swapModel(type) {
    if (type == 0) {
      this.displayModel = {
        from: this.modelFilter.from,
        to: this.modelFilter.to,
        source: this.modelFilter.callType,
        calleds: this.modelFilter.called,
        caller: this.modelFilter.caller,
        callId: this.modelFilter.callId,
        duration: this.modelFilter.duration,
        campaigns: this.modelFilter.campaignId,
        queues: this.modelFilter.queueId,
        agents: this.modelFilter.username,
        acdTimeGt: this.modelFilter.acdTimeGt,
        acdTimeLt: this.modelFilter.acdTimeLt,
        connectStatus: this.modelFilter.connectStatus,
      };
    } else {
      this.modelFilter = {
        connectStatus: this.displayModel.connectStatus,
        acdTimeLt: this.displayModel.acdTimeLt,
        acdTimeGt: this.displayModel.acdTimeGt,
        from: this.displayModel.from,
        to: this.displayModel.to,
        callType: this.displayModel.source,
        called: this.displayModel.calleds,
        caller: this.displayModel.caller,
        callId: this.displayModel.callId,
        duration: this.displayModel.duration,
        campaignId: this.displayModel.campaigns,
        queueId: this.displayModel.queues,
        agentId: this.displayModel.agents,
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngAfterViewInit(): void {}

  ngOnInit() {
    if (this.user.role == this.Roles.Agent) {
      this.modelFilter.agentId = this.user.agent_id;
    }

    Observable.forkJoin([this.getAgentList(), this.getAllQueue(), this.getAllCampaign()]).subscribe(data => {
      this.loadData(1);
    });
  }

  async changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');

    const end: any = moment().format('YYYY-MM-DD HH:mm');

    switch (type) {
      case 'year': {
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    await this.loadData(1);
  }

  async loadData(research?: any) {
    this.is_loading = true;
    if (research) {
      this.currentPage = 1;
    }
    const query = {
      page: this.currentPage,
      pageSize: this.page_size,
    };

    if (this.user.role == this.Roles.TeamLeader) {
      const listAgent = this.allAgent.filter(c => c.group_id == this.user.group_id && c.id);
      this.modelFilter.groupId = listAgent.map(c => c.id.toString());
    }

    if (this.user.role == this.Roles.Agent) {
      this.modelFilter.agentId = this.user.agent_id;
    }

    this.reportService.reportHistory(query, this.modelFilter).subscribe(
      res => {
        if (res.data) {
          this.data = res.data.data;
        } else {
          this.data = [
            {
              startTime: null,
              endTime: null,
              ringTime: 0,
              connectTime: 0,
              acdTime: 0,
              callType: 0,
              waitingTime: 0,
              holdTime: 0,
              caller: null,
              called: null,
              callId: null,
              agentId: null,
              username: null,
              duration: 0,
              campaignId: null,
              queueId: null,
              url: null,
            },
          ];
        }
        if (res.data) {
          this.initPage(res.data.total || res.total || res.data.data.length);
        }
        this.data_page_divide = this.data.map(res => {
          const campaign = this.campaigns.find(c => c.id == res.campaignId);
          const queue = this.allQueue.find(c => c.id == res.queueId);
          res.display_status = HistoryConst.displayStatusColumn(res.connectTime);
          res.display_url = HistoryConst.displayFileUrlColumn(res.connectTime);
          res.agentId = HistoryConst.displayAgentColumn(res, this.allAgent);
          res.queueId = HistoryConst.displayQueueColumn(res, this.allQueue);
          res.callType = HistoryConst.callType(res.callType);
          res.duration = TimeWorker.formatSecondToHour(res.duration);
          res.waitingTime = TimeWorker.formatSecondToHour(res.waitingTime);
          res.acdTime = TimeWorker.formatSecondToHour(res.acdTime);
          res.campaignId = campaign ? campaign.text : '';
          res.queueId = queue ? queue.text : '';
          res.display_caller = showPhoneNumberInString(res.caller, this.user);
          return res;
        });
      },
      err => {},
      () => {
        this.is_loading = false;
      }
    );
  }

  submitFilter(item?: any) {
    if (item) {
      this.displayModel = item;
    }
    if (this.displayModel.from) {
      this.displayModel.from = moment(this.displayModel.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.displayModel.to) {
      this.displayModel.to = moment(this.displayModel.to).format('YYYY-MM-DD HH:mm');
    }
    this.swapModel(1);
    this.loadData(1);
  }

  async export() {
    process.onAddDownloadProcess.emit();
    const query = {
      page: this.currentPage,
      pageSize: this.page_size,
    };
    if (this.user.role == this.Roles.Agent) {
      this.modelFilter.agentId = this.user.agent_id;
    }
    this.reportService.exportHistory(query, this.modelFilter);
  }

  getAgentList() {
    return this.userService.all().map(res => {
      const agentList = [];
      res.data.list.forEach((c: any) => {
        agentList.push({
          text: c.name,
          id: c.agent_id,
          email: c.email,
          group_id: c.group_id,
        });
      });
      this.allAgent = agentList;
    });
  }

  getAllQueue() {
    return this.queueService.list({}).map(res => {
      const list = [];
      res.data.queues.forEach((c: any) => {
        list.push({
          text: c.DESCRIPTION,
          id: c.QUEUE_ID.toString(),
        });
      });
      this.allQueue = list;
    });
  }

  getAllCampaign() {
    return this.campaignService.all({}).map(res => {
      const campaignList = [];
      res.data.list.forEach((c: any) => {
        campaignList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.campaigns = campaignList;
    });
  }

  handleAction(type: any, item?: any) {
    if (type == 'display_url') {
      this.audio_path = item.url;
      if (item.display_url) {
        const config = {
          backdrop: true,
          ignoreBackdropClick: false,
          keyboard: false,
          class: 'mt-100',
        };
        this.modalRef2 = this.modalService.show(this.audioFile, config);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/history/history.component.ts